/**
 * Hook chamado UMA vez pelo app-core (`ui/modules.tsx`): liga o carregamento
 * dos dados das embarcações e adiciona as camadas ao mapa quando ele existir.
 */
import { createElement, useEffect } from 'react';
import { useMapInstance } from '../map/mapContext';
import { ClusterPopup } from './ClusterPopup';
import { createShipLayers } from './layer';
import { ShipPopup } from './ShipPopup';
import { startShipSync } from './sync';

export { refreshNavios } from './sync';

export function useShipLayers(): void {
  const map = useMapInstance((s) => s.map);

  useEffect(() => startShipSync(), []);

  useEffect(() => {
    if (!map) return;
    const { camadas, dispose } = createShipLayers(
      (dado) => createElement(ShipPopup, { dado }),
      (grupo) => createElement(ClusterPopup, { grupo }),
    );
    for (const c of camadas) map.addLayer(c);
    return () => {
      for (const c of camadas) map.removeLayer(c);
      dispose();
    };
  }, [map]);
}
